import {
  VStack,
  Button,
  HStack,
  Heading,
  Text,
  useColorModeValue,
  Box,
  SimpleGrid,
  Icon,
  Flex,
  IconButton,
} from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import { Outlet, useNavigate, useLocation } from "react-router-dom";
import { Helmet } from "react-helmet";
import { BsFillCreditCardFill, BsQrCode, BsCurrencyBitcoin, BsGift } from "react-icons/bs";
import { FiArrowLeft } from "react-icons/fi";

const PaymentOption = ({ icon, title, onClick, colorScheme = "brand" }) => {
  const cardBg = useColorModeValue("white", "gray.800");
  const cardBorder = useColorModeValue("gray.200", "gray.700");
  const textColor = useColorModeValue("gray.800", "white");
  const hoverBg = useColorModeValue(`${colorScheme}.50`, "whiteAlpha.100");

  return (
    <Box
      as="button"
      onClick={onClick}
      bg={cardBg}
      border="1px solid"
      borderColor={cardBorder}
      rounded="2xl"
      p={6}
      shadow="md"
      transition="all 0.3s ease"
      _hover={{
        transform: "translateY(-5px)",
        shadow: "xl",
        borderColor: `${colorScheme}.500`,
        bg: hoverBg,
      }}
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      gap={4}
      w="100%"
      h="160px"
    >
      <Box
        p={4}
        w={'4rem'}
        h={'4rem'}
        rounded="full"
        bg={`${colorScheme}.100`}
        color={`${colorScheme}.600`}
        _dark={{
          bg: `${colorScheme}.900`,
          color: `${colorScheme}.200`,
        }}
      >
        <Icon as={icon} boxSize={8} />
      </Box>
      <Text fontSize="lg" fontWeight="bold" color={textColor}>
        {title}
      </Text>
    </Box>
  );
};

const Recharge = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [clicked, setClicked] = useState(false);

  useEffect(() => {
    setClicked(false);
  }, []);

  // Premium UI Colors
  const bg = useColorModeValue("gray.50", "gray.900");
  const textColor = useColorModeValue("gray.800", "white");
  const historyBg = useColorModeValue("blue.50", "blue.900");
  const backBtnBg = useColorModeValue("gray.100", "whiteAlpha.100");
  return (
    <>
      <Helmet>
        <title>Payment | Techy India</title>
      </Helmet>

      <VStack
        w="100%"
        minH="100vh"
        bg={bg}
        spacing={0}
        align="stretch"
      >
        <Box
          p={{ base: 6, md: 10 }}
          w={{ base: "100%", lg: "calc(100% - 21%)" }} // Adjust for sidebar width if needed, or keep 100%
          ml={{ lg: "auto" }} // Push to right if sidebar is present
          mx="auto" // Center if no sidebar
          maxW="1200px"
        >
          <VStack spacing={8} align="start" w="100%">
            <VStack align="start" spacing={2}>
              <Heading
                fontSize={{ base: "2xl", md: "4xl" }}
                fontWeight="800"
                color={textColor}
                letterSpacing="-0.5px"
              >
            {location.pathname !== "/payment" &&    <IconButton
                  aria-label="Back to payment methods"
                  icon={<FiArrowLeft size={24} />}
                  variant="ghost"
                  onClick={() => navigate('/payment')}
                  color={textColor}
                  _hover={{ bg: backBtnBg, transform: "translateX(-2px)" }}
                  transition="all 0.2s"
                  rounded="full"
                />}
                Add Money to <Text as="span" color="brand.500">Wallet</Text>
              </Heading>
              <Text color="gray.500" fontSize="lg">
                Securely add funds to your account using your preferred method.
              </Text>
            </VStack>

            {location.pathname === "/payment" && (
              <VStack w="100%" spacing={8}>
                <SimpleGrid columns={{ base: 1, sm: 2, md: 3 }} spacing={6} w="100%">
                  <PaymentOption
                    icon={BsQrCode}
                    title="UPI Payment"
                    onClick={() => {
                      navigate('/payment/upi');
                      setClicked(true);
                    }}
                    colorScheme="green"
                  />
                  {/* <PaymentOption
                    icon={BsCurrencyBitcoin}
                    title="Crypto Currency"
                    onClick={() => {
                      navigate('/payment/crypto');
                      setClicked(true);
                    }}
                    colorScheme="orange"
                  /> */}
                  <PaymentOption
                    icon={BsGift}
                    title="Promo Code"
                    onClick={() => {
                      navigate('/payment/promocode');
                      setClicked(true);
                    }}
                    colorScheme="purple"
                  />
                </SimpleGrid>

                <Box w="100%" pt={4}>
                  <Flex
                    justify="center"
                    align="center"
                    w="100%"
                    bg={historyBg}
                    p={6}
                    rounded="xl"
                    border="1px dashed"
                    borderColor="blue.300"
                  >
                    <Button
                      variant="ghost"
                      rightIcon={<BsFillCreditCardFill />}
                      onClick={() => navigate('/transaction')}
                      size="lg"
                      colorScheme="blue"
                      fontSize="1.1rem"
                      fontWeight="bold"
                      _hover={{ bg: "blue.100", _dark: { bg: "blue.800" } }}
                    >
                      View Transaction History
                    </Button>
                  </Flex>
                </Box>
              </VStack>
            )}

            <Box w="100%">
              <Outlet />
            </Box>
          </VStack>
        </Box>
      </VStack>
    </>
  );
};

export default Recharge;
